(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/wagers-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/wagers-service.js');
'use strict';

const isServer = typeof exports === 'object';
let jupiterHelper;
if (isServer) {
  const path = require('path');
  jupiterHelper = require(path.join(__dirname, 'jupiter-helper.es6'));
} else {
  jupiterHelper = svs.arena.service.jupiterHelper;
}
const getTeamWagersAsync = async (teamId, req) => {
  const options = {
    method: 'GET',
    path: "/social/1/syndicates/".concat(teamId, "/wagers"),
    req
  };
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return {
    data: data || [],
    error
  };
};
const exportedFunctions = {
  getTeamWagersAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.wagersService = exportedFunctions;
}

 })(window);